import React, { useState, useEffect } from "react"

import "../../styles/Common/DynamicCard.less"
import CircleIcon from "./CircleIcon"
import ClaimLogo from "../../assets/ClaimForSureLogo.svg"

import { observer } from "mobx-react"
import AppStore from "../../Configs/Store"
import BenefitStore from "../../Configs/Store/benefit"
import FormStore from "../../Configs/Store/forms"
import { DataLayerFn } from "../../Configs/API"
import DOMPurify from "dompurify"
import Image from "./Image"

const DynamicCard = observer((props) => {
  const device = AppStore.device
  // const cardInModal = useStoreState((state) => state.benifitsCard.modalMode)
  const detailedMode = BenefitStore.detailedMode
  const setDetailedMode = BenefitStore.setDetailedMode
  const [cardCollapsed, setCollapsed] = useState(true)

  let wrapper = props.wrapperStyle
  let titleBodyWrapper = props.titleBodyWrapperStyle
  let title = props.titleStyle
  let content = props.contentStyle
  let dot = props.dotStyle
  let arrowUrl = props.arrowUrl
  let arrowStyle = props.arrowStyle
  let icon = props.iconStyle
  let forDataLayer = props.dataLayerEvent

  if (device === 1) {
    if (detailedMode) {
      if (cardCollapsed && props.expandable) {
        wrapper = "HideCard"
      } else if (props.expandable) {
        wrapper = "DynamicCardPCWrapperExpanded"
        title = "DynamicCardTitlePCExpanded"
        arrowStyle = "arrowPCsmExpand"
      }
    }
  }

  useEffect(() => {
    if (BenefitStore.modalMode) {
      setDetailedMode(false)
    }
  }, [BenefitStore.modalMode])

  const handleExpand = async () => {
    var eventName = forDataLayer.split("|")[0]
    var optionText = forDataLayer.split("|")[1].replace(/<\/?[^>]+(>|$)/g, "")
    if (!detailedMode) {
      DataLayerFn(eventName + "||Calculator-Landing page|Benefits", FormStore, "", "", optionText, "")
    }
    if (!detailedMode) {
      await setDetailedMode(true)
      DataLayerFn("PlanBenefits_PopupOpen||Calculator-Landing page|Plan Benefits Desktop", FormStore, "", "", optionText, "")
      setCollapsed(false)
    }
  }
  const handleCollapse = async () => {
    var optionText = forDataLayer.split("|")[1].replace(/<\/?[^>]+(>|$)/g, "")
    if (detailedMode) {
      setCollapsed(true)
      await setDetailedMode(false)
      DataLayerFn("PlanBenefits_PopupClose||Calculator-Landing page|Plan Benefits", FormStore, "", "", optionText, "")
    }
  }

  return (
    <div
      // ref={myRef}
      className={wrapper}
      onClick={props.expandable && device === 1 ? handleExpand : props.onClick}
    >
      {props.claimCard && (
        <div className="ClaimForSureRoot" onClick={props.handleClickForClaim}>
          <img src={ClaimLogo} />
        </div>
      )}
      <div className="iconCrossWrap">
        {props.dot ? (
          <div className={dot}>
            {props.icon ? (
              // <Image className={icon} src={`assets/${props.data.iconId}.svg`} />
              <CircleIcon defer={false} iconStyle={icon} iconUrl={props.data.iconId} />
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
        {props.cross ? <CircleIcon iconUrl={"common/Iconionic-md-close-circle-outline"} onClick={props.crossOnClick} /> : ""}
      </div>
      <div className={titleBodyWrapper}>
        {props.title ? <div className={title} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.data.title) }}></div> : ""}

        {detailedMode || props.content ? <div className={content} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.data.content) }}></div> : ""}

        {props.customComp}
      </div>
      {props.arrow ? <Image defer={false} src={`assets/${arrowUrl}.svg`} className={arrowStyle} alt={""} onClick={handleCollapse} /> : ""}
    </div>
  )
})

export default DynamicCard
